import { DXTRADE_POSITION_EFFECT } from '../../utils/constants'
import { PortfolioFiltersType, type PendingFiltersType } from '../components/FiltersRow'
import type { HistoryFilters } from './usePortfolioHistory'

export function usePortfolioActiveFilters(
  openFilters: PortfolioFiltersType,
  pendingFilters: PendingFiltersType,
  historyFilters: HistoryFilters
) {
  const hasOpenActiveFilters = Boolean(
    openFilters.side || openFilters.openTimeFrom || openFilters.openTimeTo
  )

  const hasPendingActiveFilters = Boolean(
    pendingFilters.side ||
      pendingFilters.ofType ||
      pendingFilters.issuedFrom ||
      pendingFilters.issuedTo
  )

  const hasHistoryActiveFilters = Boolean(
    historyFilters.side ||
      historyFilters.ofType ||
      historyFilters.issuedFrom ||
      historyFilters.issuedTo ||
      (historyFilters.positionEffect &&
        historyFilters.positionEffect !== DXTRADE_POSITION_EFFECT.CLOSE)
  )

  return { hasOpenActiveFilters, hasPendingActiveFilters, hasHistoryActiveFilters }
}
